import { useUser } from "@/auth/provider/UserContext";
import { FeatureKey } from "@/viaduct-api";

export function useEntitlements() {
  const { orgUser } = useUser();

  const checkEntitlement = ({ key }: { key: FeatureKey }) => {
    return orgUser.org.entitlements.some(
      (e) => e.feature_key === key && e.is_enabled,
    );
  };

  return {
    checkEntitlement,
  };
}
